__turbopack_context__.v({
  "mapRoot": "YandexMap-module-scss-module__vq4IFq__mapRoot",
});
